import React, { useState, useRef, useEffect } from 'react';
import State from "../State";
import MyPageService  from "./MyPageService";
import './MyPage.css';
import ClipLoader from "react-spinners/ClipLoader";
import {useSearchParams} from "react-router-dom";
import Receipt from "./Receipt";
import {useReactToPrint} from "react-to-print";
import EntityApi from "../Api/EntityApi";
import CopyIcon from "../components/CopyIcon";

function MyPage({jsonServer}) {
    const componentRef = useRef(null);
    const handlePrint = useReactToPrint({ contentRef: componentRef });

    const [state] = useState(new State(useState(0)));

    const service = new MyPageService(jsonServer, state);
    const entityApi = new EntityApi(jsonServer);
    let [searchParams] = useSearchParams();

    useEffect(() => {
        service.fetchApplication(searchParams.get('lRef'));
    }, []);


    if (state.loading) {
        return (
            <div>
                <ClipLoader loading={state.loading} size={150} />
            </div>
        );
    }
    if (state.refMissing) {
        return (
            <div>
                {state.errorMsg ? (<span className="errorMessage">{state.errorMsg}<br/></span>) : '' }
                Ange inloggningskoden du fick vid registrering för att komma åt din data. Även Swish-referensen från betalningen fungerar när betalningen har registrerats,
                vilket normalt sker inom 24h från att betalningen har gjorts.<br/>
                <input value={state.lref} onChange={(e) => state.setLRef(e.target.value)}/> <button onClick={() => service.lrefGiven()}>Hämta</button> <br/>
                <input id="saveRef" type="checkbox" value={state.saveRef}
                       onChange={(e) => state.setSaveRef(e.target.checked)}/> <label htmlFor="saveRef">Håll mig inloggad på denna enhet</label>
                &nbsp;(Detta lagrar din inloggningskod i din webb-läsare)
            </div>
        );
    }
    const app = state.application;
    const qrCode = (app) => {
        return (
            <>
                <h3>Betalning</h3>

                Betalning skall ske via swish till nummer <b>{state.competition.swishNo}</b>&nbsp;
                <CopyIcon text={ state.competition.swishNo } title="Kopiera nummer"/>
                &nbsp;
                ({state.competition.paymentReceiver})
                eller bankgiro: <b>{state.competition.bgNo}</b>.<br/>

                Ange <b>Kanallöpet {app.reference}</b>&nbsp;
                <CopyIcon text={ 'Kanallöpet ' + app.reference }/>
                &nbsp;
                på betalningen. Anmälan är giltig först när betalning skett.<br/>
                Manuell kontroll av betalning görs dagligen och först därefter uppdateras betalstatus
                på anmälningssammanställningen och på 'Min sida'. När betalningen är registrerad
                kan du skriva ut ett kvitto från 'Min sida'.

                <br/>
                <br/>
                Sitter du vid en dator kan du skanna QR-koden nedan med Swish-appen i din telefon för att få Swish-betalningen
                förifylld. Har du anmält dig med din telefon, kan du kopiera telefonnummer och meddelandet genom
                att klicka på kopieringssymbolen och klistra in i respektive fält i Swish-appen, fylla i beloppet
                och Swisha på vanligt sätt.

                <br/>
                <br/>

                Kvar att betala: <span className="totalFee">{app.fee - app.paid} kr</span>
                <br/>
                <img src={jsonServer.baseUrl + '/admin/qr.php?db=' + entityApi.db + '&ref=' + app.reference}
                     width="300" height="300" alt="Swish QR-kod"/>
                <br/>
                <i>Om du skannar QR-koden, får du alla betaluppgifter förifyllda.</i>
                <br/>
            </>

        )
    }
    const inviteUrl = window.location.href.split('?')[0] + '?lRef=' + app.longReference;
    const team = app.team && app.team.length ? app.team[0] : null;

    return (
        <>
             {state.errorMsg ? (<span className="errorMessage">{state.errorMsg}</span>) : '' }

            <div>
            <h1>Min sida</h1>
                E-post kontaktperson: {app.email}
                { team ? (
                    <>
                        <h3>Lag</h3>
                        {team.name}
                    </>
                ) : ''}

                <h3>Löpare</h3>
                {
                    app.runners.map((a) => {
                        if (a.status === 'Borttagen') {
                            return null;
                        }
                        //const selectedClass = state.classes.filter(c => c.id === a.competitionClass)[0];
                        return (
                            <p key={a.id}>
                                {a.firstName} {a.lastName}, {a.club}, {a.competitionClass.name}{a.bus ? ', buss' : ''}, {a.fee} kr
                            </p>
                        )
                    })
                }

                Avgift: <span className="totalFee">{app.fee} kr</span>,
                Betalt: <span className="totalFee">{app.paid} kr</span>
                <br/>
                Din referens: {app.reference}<br/>

                <h3>Inloggningsuppgifter</h3>
                {!app.longReference ? '' : (<>
                    Inloggningskod: <span title={app.longReference}>*****</span>&nbsp;
                    <CopyIcon text={app.longReference} title="Kopiera kod"/>
                   <br/>
                    <a title={inviteUrl} href={inviteUrl}>Länk för att dela inloggning</a>&nbsp;
                    <CopyIcon text={ inviteUrl } title="Kopiera länk"/>
                    <br/>
                </>)}
                <br/>
                {state.saveRef ? '' : (<>
                    För att slippa ange kod vid nästa besök på 'Min sida': <button
                    onClick={() => service.saveLRef()}>Håll mig inloggad på denna enhet</button><br/>
                    <span className="tiny">(Detta lagrar din inloggningskod i din webb-läsare)</span>
                </>)}
                <br/>
                <br/>
                <button onClick={() => {
                    service.logOut()
                }}>Logga ut
                </button>
                <hr/>
                {app.paid < app.fee ? qrCode(app) : (<> <i className="fa fa-print action-icon" title="Skriv ut kvitto"
                                                           onClick={() => {
                                                               handlePrint()
                                                           }}></i><Receipt
                    ref={componentRef} service={service} state={state}/></>)}




            </div>
        </>
    );
}

export default MyPage;